import { Component } from '@angular/core';
import { Role } from '../../model/auth/Role';
import { LocationService } from '../../service/location.service';
import { Region } from '../../model/location/Region';
import { SchoolSelectResult } from '../../profile/school-select/school-select.component';
import { School, SchoolType } from '../../model/location/School';
import { NotificationHandler } from '../../helper/notification.handler';
import { MobileAwareComponent } from '../../common/mobile-aware/mobile-aware.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import {
  SchoolDetailsData,
  SchoolModifyDetailsModalComponent
} from '../school-modify-details-modal/school-modify-details-modal.component';
import { MatDialog } from '@angular/material/dialog';
import {
  DeleteConfirmationData,
  DeleteConfirmationModalComponent,
  DeleteContext
} from '../../common/modal/delete-confirmation-modal/delete-confirmation-modal.component';


@Component({
  selector: 'app-schools-manage',
  templateUrl: './schools-manage.component.html',
  styleUrls: ['./schools-manage.component.scss']
})
export class SchoolsManageComponent extends MobileAwareComponent {

  readonly roles = [Role.Host, Role.Admin];

  region?: Region;
  schoolType?: SchoolType;
  school?: School | null;

  inProgress = false;

  deleteAllowed = false;

  constructor(private locationService: LocationService,
              private dialog: MatDialog,
              breakpointObserver: BreakpointObserver) {
    super(breakpointObserver);
  }

  async initContent() {
  }

  handleRolesLoaded(roles: Role[]) {
    this.deleteAllowed = roles.includes(Role.Admin);
  }

  regionSelected(region: Region) {
    if (this.region && this.region.id != region.id) {
      this.school = null;
    }

    this.region = region;
  }

  schoolSelected(result: SchoolSelectResult) {
    const school = result && result.school ? result.school : null;
    this.schoolType = result ? result.type : undefined;

    if (this.school != school) {
      this.school = school;

      if (this.school) this.loadSchool(this.school.id);
    }
  }

  loadSchool(schoolId: string) {
    this.inProgress = true;
    this.locationService.getSchoolDetails(schoolId).subscribe(school => {
      this.school = school;
      this.inProgress = false;
    }, error => {
      NotificationHandler.handleError($localize`:Notifications|School details fetch has failed message@@notifications-school-details-fetch-failed-error:School details fetch has failed`, error);
      this.inProgress = false;
    });
  }

  editSchool(school: School) {
    if (!school) return;

    const data: SchoolDetailsData = {
      school
    };
    this.dialog.open(SchoolModifyDetailsModalComponent, {
      width: '600px',
      data: data
    }).afterClosed().subscribe((data: SchoolDetailsData) => {
      this.school = data.school;
    });
  }

  addSchool() {
    this.dialog.open(SchoolModifyDetailsModalComponent, {
      width: '600px',
    }).afterClosed().subscribe((data: SchoolDetailsData) => {
      this.school = data.school;
    });
  }

  deleteSchool(school: School) {
    const data: DeleteConfirmationData = {
      title: $localize`:General|Remove action label@@general-remove-action-label:Remove`,
      itemType: $localize`:General|School term@@general-school-term:School`,
      name: school.short_name || school.name,
      actionDesc: $localize`:School List|School list delete item prompt@@school-list-delete-item-prompt:will be removed from the search list`,
      archive: true
    };

    const dialogRef = this.dialog.open(DeleteConfirmationModalComponent, {
      width: '600px',
      data: data
    });

    dialogRef.componentInstance.deleteConfirmed.subscribe((context: DeleteContext) => {
      this.locationService.deleteSchoolDetails(school.id).subscribe(() => {
          context.modal.deleteHandled();

          this.school = undefined;
        },
        error => context.modal.deleteHandled($localize`:Notifications|School delete from has failed message@@notifications-school-delete-failed-error:Removing school has failed`, error));
    });
  }
}
